// Shared demo data helpers. Keeping this separate makes the example modules
// focus on print behavior instead of test data generation details.
export interface InvoiceRow {
  sku: string;
  name: string;
  qty: number;
  total: string;
}

// Generate a long dataset so the demo can exercise automatic table pagination.
export function createInvoiceRows(count: number): InvoiceRow[] {
  return Array.from({ length: count }, (_, index) => ({
    sku: `SKU-${1000 + index}`,
    name: `Printer line item ${index + 1}`,
    qty: (index % 4) + 1,
    total: `¥${((index + 1) * 36.5).toFixed(2)}`
  }));
}
